import React from "react"
import Img from "gatsby-image"

export default function Image({ image, ...test }) {
  if (!image) {
    return null
  }
  if (image.extension === "svg") {
    return <img src={image.publicURL} {...test} />
  }
  return <Img fluid={image.childImageSharp.fluid} {...test} />
}
